<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      top="8vh"
      append-to-body>
    <div slot="footer" style="text-align: left;">
      <el-button type="primary" size="mini" :loading="exportLoading" @click="exportData">导出明细</el-button>
    </div>
    <el-table
        :data="details"
        v-loading="loading"
        size="mini"
        height="60vh"
        border
        style="width: 100%">
      <template slot="empty">
        <div v-if="!loading">暂无明细数据</div>
      </template>
      <el-table-column type="index" label="序号" width="55" align="center"/>
      <el-table-column prop="factoryNo" align="center" label="出厂编号" min-width="140"/>
      <el-table-column prop="orderNumber" align="center" label="订单号" min-width="150"/>
      <el-table-column prop="invoiceNo" align="center" label="发货单号" min-width="150"/>
      <el-table-column prop="employeeName" align="center" label="销售员" width="100"/>
      <el-table-column prop="customerName" align="center" label="客户" min-width="160"/>
      <!-- 日期列：仅展示与当前金额列取值关联的字段，其中基准日期列表头加黑加粗 -->
      <el-table-column
          v-for="col in visibleDateColumns"
          :key="col.prop"
          :prop="col.prop"
          align="center"
          :width="col.width">
        <template slot="header">
          <span :class="{ 'header-strong': highlightProp === col.prop }">{{col.label}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="amount"
          align="center"
          label="金额(万元)"
          width="110"
          :formatter="amountFormatter"/>
      <el-table-column prop="departmentName" align="center" label="区域" min-width="130"/>
    </el-table>
  </el-dialog>
</template>

<script>
  // 金额列类型 -> 该列取值关联的日期字段（弹窗仅展示这些列，数组首项为基准日期，表头加黑加粗）
  const TYPE_DATE_COLS = {
    // 已签收 / 已签收(调整后)：签收日期（不加物流周期）
    signed: ["signDate"],
    // 已发运未签收：发运日期 + 物流周期
    shippedUnsigned: ["shipDate", "shipDateCalc"],
    // 已排产未发运：交期 + 物流周期
    producedUnshipped: ["invoiceTime", "invoiceTimeCalc"],
    // 未下发（原已排产已提交）：计划调整交期 + 物流周期
    producedSubmitted: ["adjustDeliveryDate", "adjustDeliveryDateCalc"],
    // 已下单未排产：订单交期 + 物流周期
    orderedUnproduced: ["invoiceTime", "invoiceTimeCalc"],
    // 本月已下单：下单日期（不加物流周期）
    monthOrdered: ["makingDate"],
  };

  export default {
    name: "SalesRevenueDetailDialog",
    data() {
      return {
        dialogVisible: false,
        loading: false,
        exportLoading: false,
        title: "明细预览",
        detailType: "",
        highlightProp: "",
        activeProps: [],
        details: [],
        dateColumns: [
          {prop: "makingDate", label: "下单日期", width: 110},
          {prop: "invoiceTime", label: "交期", width: 110},
          {prop: "invoiceTimeCalc", label: "交期+物流周期", width: 130},
          {prop: "signDate", label: "签收日期", width: 110},
          {prop: "shipDate", label: "发运日期", width: 110},
          {prop: "shipDateCalc", label: "发运日期+物流周期", width: 140},
          {prop: "adjustDeliveryDate", label: "计划调整交期", width: 120},
          {prop: "adjustDeliveryDateCalc", label: "计划调整交期+物流周期", width: 150},
          {prop: "cycleDays", label: "物流周期(天)", width: 100},
        ],
      };
    },
    computed: {
      visibleDateColumns() {
        return this.dateColumns.filter(col => this.activeProps.indexOf(col.prop) > -1);
      },
    },
    methods: {
      amountFormatter(row, column, cellValue) {
        if (cellValue === null || cellValue === undefined || cellValue === "") {
          return "";
        }
        return (Number(cellValue) / 10000).toFixed(2);
      },
      open(type, title, details) {
        const cols = TYPE_DATE_COLS[type] || [];
        this.detailType = type || "";
        this.title = title || "明细预览";
        // 未识别的类型兜底展示全部日期列
        this.activeProps = cols.length > 0 ? cols : this.dateColumns.map(col => col.prop);
        this.highlightProp = cols.length > 0 ? cols[0] : "";
        this.details = details || [];
        this.dialogVisible = true;
      },
      exportData() {
        let rows = this.details || [];
        if (rows.length === 0) {
          return this.$message.warning("没有可导出的明细数据");
        }
        this.exportLoading = true;
        this.$http
          .postForFile("basic", "sd/salesRevenueReport/exportDetail", rows)
          .then(resp => {
            this.exportLoading = false;
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  :deep(.header-strong) {
    color: #000 !important;
    font-weight: 900 !important;
  }
</style>
